module.exports = __webpack_public_path__ + "static/media/gallery06.fce41126.jpg";